import type { AppConfig } from '../types'

export const DefaultAppConfig: AppConfig = {
  clientConfig: {},
  clientStyleProfile: {},
  config: {
    assets_prefix: '/assets',
    bundle: 'widgetLoader',
    client_guid: '',
    dashboard_accounts_index: 6,
    dashboard_accounts_location: 0,
    dashboard_activity_index: 2,
    dashboard_activity_location: 0,
    dashboard_budgets_index: 5,
    dashboard_budgets_location: 1,
    dashboard_cash_flow_index: 0,
    dashboard_cash_flow_location: 0,
    dashboard_connect_index: 7,
    dashboard_connect_location: 1,
    dashboard_insights_index: 3,
    dashboard_insights_location: 1,
    dashboard_spending_index: 1,
    dashboard_spending_location: 1,
    dashboard_survey_index: 8,
    dashboard_survey_location: 1,
    dashboard_trends_index: 4,
    dashboard_trends_location: 0,
    display_account_number_in_accounts: true,
    display_add_manual_transaction_in_transactions: true,
    display_available_balance_in_accounts: true,
    display_email_edit_field_in_settings: true,
    display_mobile_devices_in_settings: true,
    display_notification_settings_in_settings: true,
    display_only_external_accounts_in_accounts: false,
    display_password_options_in_settings: true,
    display_sms_edit_field_in_settings: true,
    display_terms_and_conditions: true,
    display_user_profile_in_settings: true,
    display_user_transaction_rules_in_settings: true,
    display_widget_headings: true,
    enable_add_account_in_zero_state: true,
    enable_aggregation_prompts: true,
    enable_external_accounts_in_goals_widget: true,
    enable_funds_transfers_in_goals_widget: false,
    enable_manual_accounts: true,
    enable_mark_account_closed_for_held_accounts: true,
    enable_mark_account_duplicate_for_held_accounts: true,
    enable_renaming_home_accounts: true,
    enable_support_requests: false,
    language: 'en-US',
    product_name: 'Money Dashboard',
    session_token: '',
    show_account_nicknames_in_master: false,
    show_accounts_widget_in_master: true,
    show_budgets_widget_in_master: true,
    show_carousel_card_border_in_pulse_micro_widget: false,
    show_cash_flow_widget_in_master: true,
    show_connections_widget_in_master: true,
    show_debts_widget_in_master: true,
    show_finstrong_widget_in_master: true,
    show_full_experience_link_in_pulse_micro_widget: false,
    show_full_experience_link_in_pulse_mini_widget: false,
    show_goals_widget_in_master: true,
    show_help_widget_in_master: true,
    show_horizontal_padding_in_pulse_micro_widget: true,
    show_icon_in_pulse_micro_widget: true,
    show_insights_widget_in_master: true,
    show_investments_widget_in_master: false,
    show_mx_branding: true,
    show_navigation_controls_in_pulse_micro_widget: true,
    show_net_worth_widget_in_master: true,
    show_notifications_widget_in_master: true,
    show_recurring_transactions_widget_in_master: true,
    show_settings_widget_in_master: true,
    show_spending_plan_widget_in_master: false,
    show_spending_widget_in_master: true,
    show_transactions_widget_in_master: true,
    show_trends_widget_in_master: true,
    type: 'money-dashboard',
    websocket: {
      hmac: '',
      token: '',
      url: '',
    },
    widgets_display_name: 'Money Dashboard ',
  },
  honeyBadgerPublicKey: '',
  options: {
    assets_prefix: '/assets',
    brokaw_auth: {
      token: '',
      hmac: '',
      url: '',
    },
    brokaw_websocket_url: '',
    bundle: 'widgetLoader',
    custom_copy_namespace: '',
    language: 'en-US',
    product_name: 'Master Widget',
    session_token: '',
    subtype: 'master',
    type: 'money_dashboard',
  },
  postHogPublicKey: 'phc_1fVYJICC69TpW4wagp9o2XqQ8E7X98cAmcR5psSpfkE',
  userFeatures: [],
}
